// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__K7Xi7","rotation":"Loading_rotation__CxwL6","small":"Loading_small__BXD4b","isBlack":"Loading_isBlack__ldYQI"};